import React from 'react';
import Icon from '../../../components/AppIcon';

const CultureValueCard = ({ icon, title, description, color }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-300 hover:scale-102 group">
      <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-4 ${color} group-hover:scale-110 transition-transform duration-300`}>
        <Icon name={icon} size={28} color="var(--color-primary)" strokeWidth={2.5} />
      </div>
      <h3 className="text-xl font-bold text-foreground mb-3">{title}</h3>
      <p className="text-muted-foreground leading-relaxed">{description}</p>
    </div>
  );
};

export default CultureValueCard;